module.exports = __webpack_public_path__ + "static/media/0030.4937a2ac.jpg";